import { Maybe } from 'maybeasy';

export function formattedDate(dateTime: Maybe<Date>): string {
  return dateTime.map(formatDate).getOrElseValue('');
}

export function formatDate(dateTime: Date): string {
  const date = new Date(dateTime);
  return date.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
}
